import { useEffect, useState, useCallback } from "react";
import AdminHeader from "../header";
import InnerPage from "./innerPage";
import FeatherIcon from "feather-icons-react";
import Footer from "../../footer";
import { Link } from "react-router-dom";
import CourseServices from "../../../services/CourseServices";
import {showsuccessAlert} from '../../../services/AlertService';

const AdminCourse = () => {
  const [courses, setCourses] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchCourses = useCallback(async () => {
    try {
      const response = await CourseServices.getAllCourses({
        page: currentPage,
        search,
      });
      console.log(response);
      setCourses(response.courses); // Ensure this is an array
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  }, [currentPage, search]);

  const handleDelete = async (courseId) => {
    try {
      await CourseServices.deleteCourse(courseId);
      showsuccessAlert('Course deleted successfully!')
      // alert('Course deleted successfully!');
      fetchCourses(); // Refresh the course list
    } catch (error) {
      // console.error('Error deleting course:', error);
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);

  return (
    <>
      <div className="main-wrapper">
        <AdminHeader activeMenu={"CourseList"} />
        <div className="breadcrumb-bar">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/home">Home</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Courses
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        All Courses
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="course-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* Filter */}
                <div className="showing-list">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="d-flex align-items-center">
                        <div className="view-icons">
                          <Link to="/course-list" className="list-view active">
                            <FeatherIcon icon="list" />
                          </Link>
                        </div>
                        <div className="show-result">
                          <h4>{courses.length} of {totalPages} pages</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="show-filter add-course-info">
                        <form>
                          <div className="row gx-2 align-items-center">
                            <div className="col-md-9 col-item">
                              <div className="search-group">
                                <FeatherIcon icon="search" className="me-2" />
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search our courses"
                                  value={search}
                                  onChange={handleSearch}
                                />
                              </div>
                            </div>
                            <div className="col-md-3 col-item">
                              <div className="search-group">
                                <Link to="/add-course" className="btn btn-primary">
                                  Add
                                </Link>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Filter */}
                <InnerPage courses={courses} onDelete={handleDelete} />
                <div className="pagination d-flex justify-content-center mt-4">
                  <button
                    className="btn btn-outline-primary me-2"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages).keys()].map((num) => (
                    <button
                      key={num + 1}
                      className={`btn ${
                        currentPage === num + 1 ? 'btn-primary' : 'btn-outline-primary'
                      } me-2`}
                      onClick={() => handlePageChange(num + 1)}
                    >
                      {num + 1}
                    </button>
                  ))}
                  <button
                    className="btn btn-outline-primary"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default AdminCourse;
